let id = 1;

const PREFIX = 'surrogate_';

const surrogateId = () => {
    id++;

    return PREFIX + id.toString();
};

export const isSurrogateId = (id: string) => id.indexOf(PREFIX) === 0;

export default surrogateId;
